export const isObject = (value) => {
    return typeof value === 'object';
};